import { Info } from "lucide-react";
import React, { ReactNode } from "react";

import { Grid, IconButton, TypographyProps } from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";

interface IgHeaderWTooltipProps extends TypographyProps {
  sectionTitle: string;
  tooltipMessage: ReactNode;
  iconFontSize?: string;
  isSharing?: boolean;
}

/**
 * @see IgTooltip
 * @see Grid
 * @see IconButton
 */
export const IgHeaderWTooltip = ({
  tooltipMessage,
  sectionTitle,
  iconFontSize,
  isSharing,
  ...props
}: IgHeaderWTooltipProps) => {
  const { variant, fontWeight, ...rest } = props;
  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      id={"ig-header-w-tooltip"}
    >
      <Grid
        item
        id={"ig-header-w-tooltip-section-title-grid"}
        sx={isSharing ? { textAlign: "start", minWidth: "300px" } : undefined}
      >
        <IgTypography
          variant={variant || "h3"}
          fontWeight={fontWeight || 600}
          {...rest}
        >
          {sectionTitle}
        </IgTypography>
      </Grid>
      {isSharing || !tooltipMessage ? null : (
        <Grid item id={"ig-header-w-tooltip-tooltip-grid"}>
          <IgTooltip title={tooltipMessage}>
            <IconButton size={"small"} aria-label="info">
              <Info
                size={iconFontSize ?? "20px"}
                // fontSize={"small"}
              />
            </IconButton>
          </IgTooltip>
        </Grid>
      )}
    </Grid>
  );
};
